import React, { Component } from 'react';
import { connect } from 'react-redux';

import MinimalNavComponent from './MinimalNavComponent.js';
import MinimalHeaderComponent from './MinimalHeaderComponent.js';

import { HeaderNav } from './MinimalHeaderNavComponentStyle.js';

class HeaderNavComponent extends Component {
    render() {
        return (
            <HeaderNav className="entete" id="entete">
                <div className="flex-container-v">
                    <MinimalHeaderComponent />
                    <MinimalNavComponent />
                </div>
            </HeaderNav>
        );
    }
}

export default connect(null)(HeaderNavComponent);



// WEBPACK FOOTER //
// ./src/components/header/minimal/MinimalHeaderNavComponent.js